import React, { Fragment } from "react";
import { Route, Redirect } from "react-router-dom";
import SideNavBar from "../common/SideNavBar";

const ProtectedRoute = ({
  component: Component,
  displaySideNavBar,
  ...rest
}) => (
  <Fragment>
    {displaySideNavBar && <SideNavBar />}
    <div className={displaySideNavBar ? "container-with-sidebar" : ""}>
      <Route
        {...rest}
        render={props => {
          const authorize = () =>
            JSON.parse(window.sessionStorage.getItem("user"));
          return authorize() ? <Component {...props} /> : <Redirect to="/" />;
        }}
      />
    </div>
  </Fragment>
);
export default ProtectedRoute;
